import { Button, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { ContentWrapper, FooterWrapper, HeaderWrapper } from './styles';

type BaseModalProps = {
  children: React.ReactNode;
  title: string;
  btnText: string;
  handleCancel: () => void;
  handleConfirm?: () => void;
  disabledConfirm?: boolean;
};

export const BaseModal = ({
  children,
  title,
  btnText,
  handleCancel,
  handleConfirm,
  disabledConfirm = false
}: BaseModalProps) => {
  const { t } = useTranslation(['common']);

  return (
    <Grid2>
      <HeaderWrapper>
        <Typography variant="h4">{title}</Typography>
      </HeaderWrapper>
      <ContentWrapper>{children}</ContentWrapper>
      <FooterWrapper>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={handleCancel} sx={{ minWidth: '150px' }}>
            {t('cancel', { ns: 'common' })}
          </Button>
          {handleConfirm && (
            <Button onClick={handleConfirm} disabled={disabledConfirm} variant="contained" sx={{ minWidth: '150px' }}>
              {btnText}
            </Button>
          )}
        </Stack>
      </FooterWrapper>
    </Grid2>
  );
};
